/* RESPONSIBLE TEAM: team-inbox-management */

import type Session from 'embercom/services/session';
import { buildCycleOrder, resolveCurrentSelected, normalizeLocale } from './language-selection';

export function computeTranslationUi(params: {
  session: Session;
  available: string[];
  preferred?: string;
  defaultLang?: string;
  original?: string;
  selectedLangCode?: string;
}): {
  cycleOrderCodes: string[];
  currentSelectedCode: string | undefined;
} {
  let { available, preferred, defaultLang, original, selectedLangCode } = params;

  let order = buildCycleOrder({ available, preferred, defaultLang, original });

  // Special case: if preferred equals original, ensure the original language is first
  // This covers cases where the preferred code is not in `available` because it's the original
  let normPreferred = normalizeLocale(preferred);
  let normOriginal = normalizeLocale(original);
  if (normPreferred && normOriginal && normPreferred === normOriginal) {
    let idx = order.indexOf(normOriginal);
    if (idx > 0) {
      order.splice(idx, 1);
      order.unshift(normOriginal);
    } else if (idx === -1) {
      order.unshift(normOriginal);
    }
    // de-dup just in case
    order = order.filter((code, i) => order.indexOf(code) === i);
  }

  let current = resolveCurrentSelected(selectedLangCode, order);

  return {
    cycleOrderCodes: order,
    currentSelectedCode: current,
  };
}
